module.exports = __webpack_public_path__ + "img/fake-user-3.c72ef5f5.png";